@if (!hasInitials()) {
  <span
    class="td-wb-avatar__container"
    [ngClass]="{ 'td-wb-avatar__container--outlined': isOutlined(),
        'td-wb-avatar__container--solid': !isOutlined(),
        'td-wb-avatar__container--small': isSmall() }">
  <td-wb-icon class="td-wb-avatar__icon"
              iconId="avatar--small"
              size="18" />
</span>
}
@if (hasInitials()) {
  <span
    class="td-wb-avatar__container td-wb-avatar__container--initial"
    [ngClass]="{ 'td-wb-avatar__container--outlined': isOutlined(),
        'td-wb-avatar__container--solid': !isOutlined() && !isLogo(),
        'td-wb-avatar__container--small': isSmall(),
        'td-wb-avatar__container--logo': isLogo(),
        'td-wb-avatar__container--extra-small': isExtraSmall() }">
    <span [innerText]="initials()"></span>
</span>
}
